export default __webpack_public_path__ + "88fca6351e427cd38fd39741bf73156e.png";